import { MnoStatus } from '@/constants/enum';

export const remapTCRStatus = (status, fallback = 'N/A') => {
  if (status === 'ACTIVE') {
    return status;
  } else if (status === 'EXPIRED') {
    return 'DEACTIVATED';
  } else {
    return fallback;
  }
};

export const getBadgeTypeForMnoStatus = (value) => {
  if (value === MnoStatus.Review || value === MnoStatus.Rejected) {
    return 'warning';
  }
  if (value === MnoStatus.Registered) {
    return 'success';
  }
  if (value === MnoStatus.Suspended) {
    return 'error';
  }
  return 'neutral';
};
